import { environment } from "../../../environments/environment";
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class ApiConfig{
	constructor(private http: HttpClient){}

	private API_HOST_ENV:string = '';
	private API_HOST_PAY_ENV:string = '';
	private APP_HOST_CREATECARDTOKEN_ENV:string = '';
	private APPLE_PAY_TOKEN_NOTIFICATION_URL_ENV:string = '';
	private GOOGLE_PAY_TOKEN_UPDATE_URL_ENV:string = '';
	private configPromise: Promise<any> | null = null;

	// Memoized: the app's APP_INITIALIZER already awaits this once at bootstrap, but
	// components (e.g. RecaptchaWrapperComponent) call it again to be safe. Without
	// caching, every one of those calls re-fetches api-config.json from scratch and
	// adds to the page's load time for no reason - cache the in-flight/resolved
	// promise so repeat callers get it for free.
	public getConfig(){
		if (this.configPromise) return this.configPromise;

		this.configPromise = new Promise((resolve,reject)=>{
			this.http.get('../../../assets/config/api-config.json')
			.subscribe((response:any)=>{

				this.API_HOST_ENV = response.API_HOST_LOCAL;
				this.APP_HOST_CREATECARDTOKEN_ENV = response.API_HOST_LOCAL_WEBPAY;
				this.API_HOST_PAY_ENV = response.API_HOST_LOCAL_PAY;
				this.APPLE_PAY_TOKEN_NOTIFICATION_URL_ENV = response.APPLE_PAY_TOKEN_NOTIFICATION_URL_LOCAL;
				this.GOOGLE_PAY_TOKEN_UPDATE_URL_ENV = response.GOOGLE_PAY_TOKEN_UPDATE_URL_LOCAL;
				if(environment){
					console.log("Enviroment:", environment);
					if(environment.production){
						this.API_HOST_ENV = response.API_HOST_PRODUCTION;
						this.APP_HOST_CREATECARDTOKEN_ENV = response.API_HOST_PRODUCTION_WEBPAY;
						this.API_HOST_PAY_ENV = response.API_HOST_PRODUCTION_PAY;
						this.APPLE_PAY_TOKEN_NOTIFICATION_URL_ENV = response.APPLE_PAY_TOKEN_NOTIFICATION_URL_PRODUCTION;
						this.GOOGLE_PAY_TOKEN_UPDATE_URL_ENV = response.GOOGLE_PAY_TOKEN_UPDATE_URL_PRODUCTION;
					}else if(environment.staging){
						this.API_HOST_ENV = response.API_HOST_STAGING;
						this.APP_HOST_CREATECARDTOKEN_ENV = response.API_HOST_STAGING_WEBPAY;
						this.API_HOST_PAY_ENV = response.API_HOST_STAGING_PAY;
						this.APPLE_PAY_TOKEN_NOTIFICATION_URL_ENV = response.APPLE_PAY_TOKEN_NOTIFICATION_URL_STAGING;
						this.GOOGLE_PAY_TOKEN_UPDATE_URL_ENV = response.GOOGLE_PAY_TOKEN_UPDATE_URL_STAGING;
					}else if(environment.hmr){
						this.API_HOST_ENV = response.API_HOST_TEST_SQL_STAGING_PRODUCTION; //For testportal
						this.APP_HOST_CREATECARDTOKEN_ENV = response.API_HOST_TEST_SQL_STAGING_PRODUCTION_WEBPAY;
						this.API_HOST_PAY_ENV = response.API_HOST_TEST_SQL_STAGING_PRODUCTION_PAY;
						this.APPLE_PAY_TOKEN_NOTIFICATION_URL_ENV = response.APPLE_PAY_TOKEN_NOTIFICATION_URL_TEST_SQL_STAGING_PRODUCTION;
						this.GOOGLE_PAY_TOKEN_UPDATE_URL_ENV = response.GOOGLE_PAY_TOKEN_UPDATE_URL_TEST_SQL_STAGING_PRODUCTION;
					}
				}
				console.log("APP_HOST_CREATECARDTOKEN:", this.APP_HOST_CREATECARDTOKEN_ENV);
				return resolve(response);
			}, reject)
		});

		return this.configPromise;
	}

	get API_HOST():string{
		return this.API_HOST_ENV;
	}

	get API_HOST_PAY():string{
		return this.API_HOST_PAY_ENV;
	}

	get APP_HOST_CREATECARDTOKEN():string{
		return this.APP_HOST_CREATECARDTOKEN_ENV;
	}

	// Static wallet setup config shared by every environment (mirrors the hybrid
	// backend's `paymentMethodSetup.applePay`/`.googlePay` config blocks) — used to
	// build Apple/Google Pay MIT payment sheets client-side in the URL-direct
	// (no Session) checkout flow.
	get APPLE_PAY_MERCHANT_CAPABILITIES(): string[] {
		return ['supports3DS'];
	}

	get APPLE_PAY_SUPPORTED_NETWORKS(): string[] {
		return ['visa', 'masterCard', 'amex', 'discover'];
	}

	get APPLE_PAY_TOKEN_NOTIFICATION_URL():string{
		return this.APPLE_PAY_TOKEN_NOTIFICATION_URL_ENV;
	}

	get APPLE_PAY_MERCHANT_IDENTIFIER(): string {
		return 'merchant.com.c9pg.cloud9';
	}

	get GOOGLE_PAY_TOKEN_UPDATE_URL():string{
		return this.GOOGLE_PAY_TOKEN_UPDATE_URL_ENV;
	}

	get GOOGLE_PAY_API_VERSION(): number {
		return 2;
	}

	get GOOGLE_PAY_API_VERSION_MINOR(): number {
		return 0;
	}

	get GOOGLE_PAY_ALLOWED_AUTH_METHODS(): string[] {
		return ['PAN_ONLY', 'CRYPTOGRAM_3DS'];
	}

	get GOOGLE_PAY_ALLOWED_CARD_NETWORKS(): string[] {
		return ['VISA', 'MASTERCARD', 'AMEX', 'DISCOVER'];
	}

	get GOOGLE_PAY_GATEWAY(): string {
		return 'c9pg';
	}

	get GOOGLE_PAY_GATEWAY_MERCHANT_ID(): string {
		return 'c9pg';
	}

	get GOOGLE_PAY_MERCHANT_ID(): string {
		return 'BCR2DN6T5O77TRRG';
	}
}